"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _unionSync = require("@/api/unionSync");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SyncQuickActions',
  data: function data() {
    return {
      syncStatus: 'idle',
      lastSyncTime: null,
      showProgress: false,
      syncProgress: 0,
      progressStatus: null,
      progressText: '',
      loading: {
        fullSync: false,
        unionBase: false,
        unionUser: false
      }
    };
  },
  computed: {
    syncStatusText: function syncStatusText() {
      var statusMap = {
        idle: '空闲中',
        running: '同步中',
        completed: '已完成',
        error: '出错'
      };
      return statusMap[this.syncStatus] || '未知';
    }
  },
  mounted: function mounted() {
    this.loadLastSyncTime();
  },
  methods: {
    loadLastSyncTime: function loadLastSyncTime() {
      this.lastSyncTime = localStorage.getItem('lastSyncTime') || null;
    },
    updateSyncProgress: function updateSyncProgress(percentage, text) {
      var status = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      this.syncProgress = percentage;
      this.progressText = text;
      this.progressStatus = status;
      this.showProgress = percentage > 0 && percentage < 100;
    },
    updateSyncStatus: function updateSyncStatus(status) {
      var _this = this;
      this.syncStatus = status;
      if (status === 'completed') {
        this.lastSyncTime = new Date().toLocaleString();
        localStorage.setItem('lastSyncTime', this.lastSyncTime);
        this.updateSyncProgress(100, '同步完成', 'success');
        setTimeout(function () {
          _this.showProgress = false;
        }, 2000);
      } else if (status === 'error') {
        this.updateSyncProgress(0, '同步失败', 'exception');
        setTimeout(function () {
          _this.showProgress = false;
        }, 3000);
      }
    },
    handleFullSync: function () {
      var _handleFullSync = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this2 = this;
        var result, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.loading.fullSync = true;
              this.updateSyncStatus('running');
              this.updateSyncProgress(10, '开始全量同步...');
              _context.p = 1;
              _context.n = 2;
              return (0, _unionSync.fullSync)();
            case 2:
              result = _context.v;
              this.updateSyncProgress(50, '同步进行中...');

              // 模拟进度更新
              setTimeout(function () {
                _this2.updateSyncProgress(80, '即将完成...');
              }, 1000);
              setTimeout(function () {
                _this2.updateSyncStatus('completed');
                _this2.$message.success('全量同步任务已启动');
                _this2.$emit('sync-completed', 'full');
              }, 2000);
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              this.updateSyncStatus('error');
              this.$message.error('全量同步失败：' + _t.message);
            case 4:
              _context.p = 4;
              this.loading.fullSync = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function handleFullSync() {
        return _handleFullSync.apply(this, arguments);
      }
      return handleFullSync;
    }(),
    handleSyncUnionBase: function () {
      var _handleSyncUnionBase = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this3 = this;
        var result, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.loading.unionBase = true;
              this.updateSyncStatus('running');
              this.updateSyncProgress(20, '同步工会信息...');
              _context2.p = 1;
              _context2.n = 2;
              return (0, _unionSync.syncUnionBase)();
            case 2:
              result = _context2.v;
              this.updateSyncProgress(70, '工会信息同步中...');
              setTimeout(function () {
                _this3.updateSyncStatus('completed');
                _this3.$message.success('工会信息同步任务已启动');
                _this3.$emit('sync-completed', 'unionBase');
              }, 1500);
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              this.updateSyncStatus('error');
              this.$message.error('工会信息同步失败：' + _t2.message);
            case 4:
              _context2.p = 4;
              this.loading.unionBase = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3, 4, 5]]);
      }));
      function handleSyncUnionBase() {
        return _handleSyncUnionBase.apply(this, arguments);
      }
      return handleSyncUnionBase;
    }(),
    handleSyncUnionUser: function () {
      var _handleSyncUnionUser = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this4 = this;
        var result, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.loading.unionUser = true;
              this.updateSyncStatus('running');
              this.updateSyncProgress(30, '同步会员数据...');
              _context3.p = 1;
              _context3.n = 2;
              return (0, _unionSync.syncUnionUser)();
            case 2:
              result = _context3.v;
              this.updateSyncProgress(75, '会员数据同步中...');
              setTimeout(function () {
                _this4.updateSyncStatus('completed');
                _this4.$message.success('会员数据同步任务已启动');
                _this4.$emit('sync-completed', 'unionUser');
              }, 1500);
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t3 = _context3.v;
              this.updateSyncStatus('error');
              this.$message.error('会员数据同步失败：' + _t3.message);
            case 4:
              _context3.p = 4;
              this.loading.unionUser = false;
              return _context3.f(4);
            case 5:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 3, 4, 5]]);
      }));
      function handleSyncUnionUser() {
        return _handleSyncUnionUser.apply(this, arguments);
      }
      return handleSyncUnionUser;
    }(),
    goToSyncPage: function goToSyncPage() {
      this.$router.push({
        name: 'unionSync'
      });
    }
  }
};